<div class="cancel">
    <div class="cancel-desc">{{ 'testDrive.areYouSureYouWantToCancel' | translate}}?</div>
    <asp-info-button class='yes' name="{{ 'service.yes' | translate }}" type="primary" (click)="closeLink($event, 'yes')"></asp-info-button>
    <asp-info-button class='no' name="{{ 'service.no' | translate }}" type="secondary" (click)="closeLink($event,'no')"></asp-info-button>
</div>
